/**
 * Bandeau d'alerte Adhesion FTPE
 * S'affiche si l'utilisateur n'a pas d'adhésion active
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, X, ArrowRight, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from '../lib/utils';
import axios from 'axios';
import { getToken } from '../services/tokenService';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AdhesionFTPEBanner({ className }) {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);
  const [, setAdhesionStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkAdhesionStatus = async () => {
      const token = getToken();
      if (!token) return;

      // Vérifier si le bandeau a été fermé récemment (session)
      const dismissedAt = sessionStorage.getItem('ftpe_banner_dismissed');
      if (dismissedAt) {
        const dismissedTime = new Date(dismissedAt);
        const hoursSinceDismissed = (new Date() - dismissedTime) / (1000 * 60 * 60);
        if (hoursSinceDismissed < 24) {
          return;
        }
      }

      try {
        const response = await axios.get(`${API}/ftpe-adhesion/my-status`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setAdhesionStatus(response.data);
        
        // Afficher le bandeau si adhésion requise mais non valide
        if (response.data.required && !response.data.valid) {
          setShowBanner(true);
        }
      } catch {
      }
    };
    
    checkAdhesionStatus();
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    setShowBanner(false);
    sessionStorage.setItem('ftpe_banner_dismissed', new Date().toISOString());
  };

  if (!showBanner || dismissed) {
    return null;
  }

  return (
    <div className={cn(
      "bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 text-white",
      "px-4 py-3 shadow-lg",
      className
    )}>
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div>
            <p className="font-semibold">
              Adhésion FTPE requise
            </p>
            <p className="text-sm text-white/80">
              Souscrivez à votre adhésion pour accéder à tous les services de la plateforme.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            onClick={() => navigate('/adhesion-ftpe-workflow')}
            className="bg-white text-orange-600 hover:bg-white/90 font-semibold"
          >
            <Shield className="w-4 h-4 mr-2" />
            Souscrire maintenant
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDismiss}
            className="text-white/70 hover:text-white hover:bg-white/10"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
